import React, { useRef, useState } from 'react'
import styles from './index.module.scss'
import { useAssetImage } from '@/platforms/utils'
import VipTop from './compoments/vipTop'
import VipInfo from './compoments/vipInfo'
import VipCard from './compoments/vipCard'
import ReceiveCashGift from './compoments/receiveCashGift'
import { useNavigate } from 'react-router'
import { useVipCfgList, useVipPromotionList } from './hooks/useVip'
import { useUserInfo } from '@/api/request'
import LoadingUI from '@/compoments/loadingUI'
import FadeIn from '@/compoments/fadeIn'
import Footer from '../casino/compoment/footer'

const Vip = () => {
  const vipBac = useAssetImage('vip-bac',{theme: true})
  const navigate = useNavigate();

  const { data: userInfo, isLoading: userLoading } = useUserInfo()
  const { data: gradeData, isLoading: configLoading} = useVipCfgList()
  
  const [grade, setGrade] = useState(Math.max(userInfo?.grade ?? 1, 1))
  // 获取vip晋级优惠配置
  const { data: configData, isLoading } = useVipPromotionList(`${grade}`) 

  return (
    <FadeIn>
      <LoadingUI loading={userLoading || configLoading || isLoading} data={userInfo || gradeData || configData} height={700} >
      <div className={styles.vip}
      style={{
        backgroundImage: `url(${vipBac})`,
        backgroundSize: '100% 1035px',
        backgroundRepeat: 'no-repeat'
      }}
      >
        
          {/* 顶部 */}
          <VipTop />

          {/* 头像 进度条 */}
          <VipInfo userInfo={userInfo} gradeData={gradeData} />

          {/* 领取奖励 */}
          <ReceiveCashGift userInfo={userInfo} gradeData={gradeData} grade={grade} configData={configData} />

          {/* vip卡片 */}
          <VipCard gradeData={gradeData} />

      </div>
      
      <div className={styles.footer}>
        <Footer />
      </div>
      </LoadingUI>
    </FadeIn>
  )
}

export default Vip
